import { useState, useEffect, useLayoutEffect } from 'react'
import { Avatar, Grid, Typography } from '@material-ui/core'

import CircularPercentage from 'components/commons/CircularPercentage'

import useStyles from './UserProgressBar.styles'
import { useStateValue } from '../../../context/store'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import { _getProfileImage } from 'components/UserAvatar/actions'
import { getFromApi } from 'actions'

const UserProgressBar = ({ Menu = <></>, hideMenu = false }) => {
   const [isBarCollapsed, setIsBarCollapsed] = useState(false)
   const [userGeneralScore, setUserGeneralScore] = useState({})
   const [{ sessionUser = {}, userAvatar = {} }, dispatch] = useStateValue()

   const classes = useStyles({ isBarCollapsed, hideMenu })
   const { score = 0, percentage = 0, totalScore = 0 } = userGeneralScore
   const { name = '', lastName = '' } = sessionUser?.settings || {}

   async function _getUserPoints() {
      const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/evaluate-user/last`
      const questionnaireUserTotalScore = await getFromApi(url)
      setUserGeneralScore(questionnaireUserTotalScore)
   }

   const getGeneralScore = useApiRequest(
      _getUserPoints,
      'Questionnaire API-UserScore'
   )

   const getProfileImage = useApiRequest(
      () => _getProfileImage(dispatch),
      'Imagen de perfil: Consultar',
      false
   )

   useEffect(() => {
      if (!userAvatar?.photo) {
         getProfileImage()
      }
   }, [])

   useLayoutEffect(() => {
      getGeneralScore()
   }, [])

   return (
      <div className={classes.buttonQuestionnaire}>
         <div className={classes.buttonQuestionnaire_box_one}>
            <div
               style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  background:
                     'transparent linear-gradient(168deg, #008FD6 0%, #154281 100%) 0% 0% no-repeat padding-box'
               }}
            >
               <div className={classes.circle_picture_user}>
                  <Avatar
                     src={userAvatar.photo}
                     className={classes.circle_picture_user_photo}
                     onClick={() => setIsBarCollapsed(prev => !prev)}
                  />
               </div>
            </div>
         </div>
         <div className={classes.buttonQuestionnaire_box_two}>
            <div
               style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px'
               }}
            >
               <h2
                  style={{
                     padding: '0',
                     margin: '0',
                     whiteSpace: 'nowrap'
                  }}
               >
                  {`${name?.split(' ')[0] || ''} ${
                     lastName?.split(' ')[0] || ''
                  }`}
               </h2>
               <Grid
                  container
                  style={{
                     padding: '0',
                     margin: '0',
                     fontSize: '10px',
                     whiteSpace: 'nowrap'
                  }}
               >
                  TU PUNTAJE {score} / {totalScore}
               </Grid>
               <div
                  style={{
                     width: 220,
                     height: '8px',
                     background: '#154281 0% 0% no-repeat padding-box',
                     borderRadius: '16px'
                  }}
               >
                  <div
                     style={{
                        width: `${(score / (totalScore || 1)) * 100}%`,
                        height: '100%',
                        background:
                           'transparent linear-gradient(180deg, #C8C837 0%, #1C6423 100%) 0% 0% no-repeat padding-box',
                        borderRadius: '16px'
                     }}
                  />
               </div>
            </div>
         </div>
         <div className={classes.buttonQuestionnaire_box_three}>
            <CircularPercentage value={percentage || 0} />
            <Typography style={{ whiteSpace: 'noWrap' }}>
               MIS AVANCES
            </Typography>
         </div>
         <div className={classes.buttonQuestionnaire_box_four}>{Menu}</div>
      </div>
   )
}

export default UserProgressBar
